import { render, staticRenderFns } from "./rechargePopup.vue?vue&type=template&id=08aceff6&scoped=true&"
import script from "./rechargePopup.vue?vue&type=script&lang=js&"
export * from "./rechargePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08aceff6",
  null
  
)

export default component.exports